import React, { Component } from "react";
import { connect } from "react-redux";

@connect(mapStateToProps)
export default class GlobalError extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let { message, customMessage } = this.props;
    let errorElement = <span></span>;

    if (customMessage) {
      message = customMessage;
    }

    if (message) {
      errorElement = (
        <div className="BookingErrorBox">
          <div id="advanced_error_msg">
            <div className="errorText">
              <div className="error_icon"></div>
              {message}
            </div>
          </div>
        </div>
      );
    }

    return errorElement;
  }
}
function mapStateToProps(state) {
  return { message: state.globalErrorReducer.message };
}
